import type { FunctionComponent } from 'react';

import { type BreadcrumbItem, Breadcrumbs } from '~/ui/core/breadcrumbs/Breadcrumbs';

export const TileBreadcrumbs: FunctionComponent<{ readonly items: readonly BreadcrumbItem[] }> = ({ items }) => (
    <div className="[&>div>div>span]:!text-gray-500 [&>div>div>button]:!text-gray-500 [&>div>div>button]:transition-colors [&>div>div>button]:duration-200 [&>div>div>button]:[transition-timing-function:ease] [&>div>div>button:hover]:!text-gray-700 [&>div>div>svg]:!text-gray-400">
        <Breadcrumbs items={items} />
    </div>
);
